<template>
  <div 
    class="p-2"
    @mouseenter="emitContextualHelpChanged('idx_visu')"
    @mousemove="emitContextualHelpChanged('idx_visu')"
    @mouseleave="emitContextualHelpChanged(-1)"
  >
    <div class="ml-1" style="width:28vw">
      <svg 
        ref="svg"
        width="100%" 
        height="100%" 
        viewBox="0 0 586 391" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        @mousedown="startMove" 
        @mousemove="move" 
        @mouseup="endMove"
        @click="moveClick"
      >
        <path d="M0.666992 391.373H266.917V356.507H194.756V320.395H0.666992V391.373Z" fill="#88B0B9" opacity="0.6"/>
        <path d="M266.917 391.373V356.507H194.756L266.917 320.395H478.424V356.507V391.373H266.917Z" fill="#9B7E9E" opacity="0.6"/>
        <path d="M0.666992 320.395H194.756V356.507L266.917 320.395V72.5957H194.756L0.666992 266.85V320.395Z" fill="#BCA264" opacity="0.6"/>
        <path d="M478.424 356.507L586.666 320.395V72.5957H478.424V0.372803H266.917L194.756 72.5957H266.917V320.395H478.424V356.507Z" fill="#788DA9" opacity="0.6"/>
        <path d="M0.666992 266.85V0.372803H266.917L0.666992 266.85Z" fill="#9D9D9D" opacity="0.2"/>
        <path d="M586.666 72.5957V0.372803H478.424V72.5957H586.666V320.395L478.424 356.507V391.373H586.666V320.395V72.5957Z" fill="#9D9D9D" opacity="0.2"/>
        <path d="M194.756 320.395V356.506L266.917 356.506V391.373H248.254L248.254 375.185H176.093L176.093 339.073L0.666942 339.074L0.666016 320.395" fill="#7CBCCA" opacity="0.6"/>
        <path d="M478.424 320.395L478.424 391.373H459.762L459.762 339.073L248.255 339.073L213.418 356.507H194.756L266.917 320.395" fill="#9A6C9F" opacity="0.6"/>
        <path d="M266.917 72.5957V320.395L194.756 356.506V347.167L248.255 320.395V91.2741H176.093L194.756 72.5957" fill="#C5A251" opacity="0.6"/>
        <path d="M478.424 0.372817V72.5957L586.666 72.5958V320.395L478.424 356.507V350.28L568.003 320.395V91.2743L459.762 91.2742V19.0512H248.255L266.917 0.372803" fill="#6284B1" opacity="0.6"/>
       
        <circle id="draggableCircle" class="clickable" :cx="pointX" :cy="pointY" r="7.5" stroke="black" fill="transparent"/>
        <circle id="draggableCircle" class="clickable" :cx="pointX" :cy="pointY" r="4" fill="#2A3038"/>
        <circle id="draggableCircle" class="clickable" :cx="pointX" :cy="pointY" r="1" fill="black"/>
     
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "CIdxVisualisation",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  props: {
    idx: Number,
    currentWidth: Number,
    currentHeight: Number
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  data () {
    return {
      isMoving: false,
      pointX: 250,
      pointY: 250,
      minHeight: 200,
      maxHeight: 514,
      minWidth: 300,
      maxWidth: 771,
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  mounted: function() {
    this.updateWidth(this.currentWidth);
    this.updateHeight(this.currentHeight);
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  methods: {
    startMove(event) {
      if (event.target.id === 'draggableCircle') {
        this.isMoving = true;
      }
    },
    ///////////////////////////////////////////////////////////////////////
    moveClick(event) {
      this.isMoving = true;
      this.move(event);
      this.isMoving = false;
    },
    ///////////////////////////////////////////////////////////////////////
    move(event) {
      if (this.isMoving) {
        const rect = event.currentTarget.getBoundingClientRect();

        let newX = event.clientX - rect.left;
        let newY = event.clientY - rect.top;

        // Calcul des limites du svg
        newX = Math.max(0, Math.min(newX, rect.width));
        newY = Math.max(0, Math.min(newY, rect.height));

        // this.userPointX = newX;
        // this.userPointY = newY;

        let newWidthRatio = newX / rect.width; // Ratio de newX par rapport à la largeur du SVG
        let newWidth = this.minWidth + (newWidthRatio * (this.maxWidth - this.minWidth));

        let invertedNewY = rect.height - newY;
        let newHeightRatio = invertedNewY / rect.height; // Ratio de newY inversé par rapport à la hauteur du SVG
        let newHeight = this.minHeight + (newHeightRatio * (this.maxHeight - this.minHeight));

        this.$emit("RoomSizeChanged", { id: "currentWidth", value: newWidth });
        this.$emit("RoomSizeChanged", { id: "currentHeight", value: newHeight });
      }
    },
    ///////////////////////////////////////////////////////////////////////
    endMove() {
      this.isMoving = false;
    },
    ///////////////////////////////////////////////////////////////////////
    updateWidth(value) {
      let svgSize = this.$refs.svg.getBBox();
      const widthRatio = (value - this.minWidth) / (this.maxWidth - this.minWidth);
      this.pointX = widthRatio * svgSize.width;
    },
    ///////////////////////////////////////////////////////////////////////
    updateHeight(value) {
      let svgSize = this.$refs.svg.getBBox();
      const heightRatio = (value - this.minHeight) / (this.maxHeight - this.minHeight);
      this.pointY = svgSize.height - (heightRatio * svgSize.height);
    },
    ///////////////////////////////////////////////////////////////////////
    emitContextualHelpChanged: function(event) {
      this.$emit('ContextualHelpChanged', event);
    }
  },
  ///////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////
  watch: {
    currentWidth(newWidth) {
      this.updateWidth(newWidth);
    },
    ///////////////////////////////////////////////////////////////////////
    currentHeight(newHeight) {
      this.updateHeight(newHeight);
    }
  }
}
</script>